// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Signal2Bars = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M24.23,29.66a3.32,3.32,0,0,1-3.32-3.32V17.89a3.32,3.32,0,0,1,6.64,0v8.45A3.32,3.32,0,0,1,24.23,29.66Zm0-14.09a2.32,2.32,0,0,0-2.32,2.32v8.45a2.32,2.32,0,1,0,4.64,0V17.89A2.32,2.32,0,0,0,24.23,15.57Z" />
            <Path d="M15.77,19.3A2.82,2.82,0,0,0,13,22.11v4.23a2.82,2.82,0,1,0,5.64,0V22.11a2.82,2.82,0,0,0-2.82-2.82Z" />
            <Path d="M15.77,29.66a3.32,3.32,0,0,1-3.32-3.32V22.11a3.32,3.32,0,0,1,6.64,0v4.23A3.32,3.32,0,0,1,15.77,29.66Zm0-9.86a2.32,2.32,0,0,0-2.32,2.32v4.23a2.32,2.32,0,1,0,4.64,0V22.11A2.32,2.32,0,0,0,15.77,19.8Z" />
            <Path d="M7.32,23.52a2.82,2.82,0,1,0,2.82,2.82,2.82,2.82,0,0,0-2.82-2.82Z" />
            <Path d="M7.32,29.66a3.32,3.32,0,1,1,3.32-3.32A3.32,3.32,0,0,1,7.32,29.66Zm0-5.64a2.32,2.32,0,1,0,2.32,2.32A2.32,2.32,0,0,0,7.32,24Z" />
            <Path d="M32.68,29.66a3.32,3.32,0,0,1-3.32-3.32V13.66a3.32,3.32,0,1,1,6.64,0V26.34A3.32,3.32,0,0,1,32.68,29.66Zm0-18.32a2.32,2.32,0,0,0-2.32,2.32V26.34a2.32,2.32,0,1,0,4.64,0V13.66A2.32,2.32,0,0,0,32.68,11.34Z" />
        </G>
    );
};

export default Signal2Bars;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/signal-2-bars/index.js